import { render } from "./NewsThumbnail.vue?vue&type=template&id=0d43064d&scoped=true"
import script from "./NewsThumbnail.vue?vue&type=script&lang=js"
export * from "./NewsThumbnail.vue?vue&type=script&lang=js"

import "./NewsThumbnail.vue?vue&type=style&index=0&id=0d43064d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d43064d"]])

export default __exports__